import * as React from "react";
import Popover from "@mui/material/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { Close, ArrowDropUp, ArrowDropDown } from "@material-ui/icons";
import {
  FormGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  RadioGroup,
  Radio,
} from "@mui/material";
import { Grid, Typography } from "@material-ui/core";

function valuetext(value) {
  return `${value} Stop(s)`;
}

export default function MaxStops(props) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const stopOptions = {
    "0": "Direct",
    "1": "One Stop",
    "2": "Two Or More",
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUpdate = (val) => {
    handleChange(val);

    setAnchorEl(null);
  };

  const handleChange = (e) => {
    if (props.onChange) props.onChange(e.target.value);
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleClear = (e) => {
    e.stopPropagation();
    handleChange(props.defaultValue);
    handleReset();
  };
  const handleReset = () => {
    if (props.onReset) props.onReset();
  };

  return (
    <FormControl
      sx={{
        "&.MuiFormControl-root": {
          display: "block",
        },
        padding: "0 1rem",
      }}
    >
      <FormLabel
        id="sortby-filter-radio-buttons-group"
        sx={{
          display: "block",
          fontWeight: "700",
          textAlign: "start",
          color: "#000000",
        }}
      >
        Max Stops
      </FormLabel>
      <RadioGroup
        aria-labelledby="sortby-filter-radio-buttons-group"
        name="controlled-radio-buttons-group"
        defaultValue="0"
        value={props.value}
        onChange={handleChange}
      >
        {Object.keys(stopOptions).map((option) => (
          <FormControlLabel
            value={option}
            control={
              <Radio
                sx={{
                  "& .MuiSvgIcon-root": {
                    fontSize: 14,
                  },
                  "&.Mui-checked": {
                    color: "#00846A",
                  },
                }}
              />
            }
            label={stopOptions[option]}
            sx={{
              "& .MuiFormControlLabel-label": {
                fontSize: "0.75rem !important",
                color: "#000000",
                fontWeight: 500,
              },
              margin: "0",
            }}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}

MaxStops.defaultProps = {
  value: "-1",
};
